import React, { useState } from 'react';
import { App } from '@/types/App';
import { ChevronRight } from 'lucide-react';

interface AppCardProps {
  app: App;
  onAppSelect: (app: App) => void;
}

const AppCard: React.FC<AppCardProps> = ({ app, onAppSelect }) => {
  const [imageError, setImageError] = useState(false);

  const handleCardClick = () => {
    onAppSelect(app);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <button 
      className="w-full text-left active:bg-muted/70 active:scale-[0.99] hover:bg-muted/50 transition-all duration-100 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-inset"
      onClick={handleCardClick}
      aria-label={`View details for ${app.name}`}
    >
      <div className="px-4 py-3 flex items-center gap-4">
        <div className="flex-shrink-0">
          {imageError ? (
            <div className="w-14 h-14 rounded-xl bg-muted flex items-center justify-center shadow-sm">
              <span className="text-2xl text-muted-foreground" aria-hidden="true">📱</span>
            </div>
          ) : (
            <img
              src={app.icon}
              alt=""
              className="w-14 h-14 rounded-xl object-cover bg-muted shadow-sm"
              loading="lazy"
              onError={handleImageError}
            />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-medium text-foreground truncate leading-snug">
            {app.name}
          </h3>
          {app.category && (
            <p className="text-sm text-muted-foreground mt-0.5 truncate">
              {app.category}
            </p>
          )}
        </div>
        <div className="flex-shrink-0 pl-2">
          <ChevronRight className="w-5 h-5 text-muted-foreground/60" aria-hidden="true" />
        </div>
      </div>
    </button>
  );
};

export default AppCard;
